export default __webpack_public_path__ + "static/media/youtube.6dc68d7d.jpg";